const APIURL = {
  AUTH: "auth",
  PROFILE: "profile",
  UPDATE_PROFILE: "updateProfile",
  VIEWS: "views",
  GET_FILTER: "filters",
  REGISTER: "register",
  VALIDATE_EMAIL: "validateUserEmail",
  VALIDATE_BUYER_EMAIL: "validateBuyerEmail",
  UPDATE_PROPERTY_STATUS: "updatePropertyStatus",
  CONTACT_US: "contactUs",
  SUBMIT: "submit",
  EMAIL: "email",
  LOGIN: "login",
  PROPERTIES: "properties",
  PROPERTY: "property",
  LOCATION: "location",
  TOP_INFO: "top-info",
  SEND: "send",
  OTP: "otp",
  VERIFY: "verify",
  MY: "my",
  LIMIT: "limit",
  FILTER: "filter",
  USER: "user",
  FAVOURITE: "favourite",
  ENQUIRIES: "enquiries",
  FORGETPASSWORD: "forgotPassword",
  MESSAGES: "messages",
  PROPERTYID: "propertyId",
  LIST: "list",
  RELATED_LISTING: "relatedListings",
  TYPE: "type",
  SALESFORCE: "salesforce",
  GET_PARTY_PROPERTIES: "getPartyProperties",
  PAYMENT: "payment",
  SERVICE_BY_PROPERTY: "servicesByProperty",
  UPLOAD_MEDIA: "upload-media",
  UPLOAD_MEDIA_FILES: "upload-media-files",
  DELETE_MEDIA: "delete-media",
  TAGS: "tags",
  STATUS: "status",
  WIDGETS: "tileCount",
  GET_PROPERTY_HISTORY: "getPropertyHistoryData",
  GET_LISTING_DATA: "getListingData",
  EDIT_PROPERTIES: "editProperties",
  SELLER: "seller",
  GET_PROPERTY_IMAGES: "getPropertyImages",
  GET_UNREAD: "getUnread",
  CMS_API: "cmsapi",
  CONFIG: "config",
  UPLOAD_DOCUMENTS: "upload-documents",
  GET_LOCATION_DATA: "getLocationData",
  RESET_PASSWORD: "resetPassword",
  INTEGRATION: "integration",
  BRIDGE: "bridge",
  EMAAR_ONE: "emaarOne",
  GET_EVENT: "getEvent",
  HEALTH: "health",
  SAVE_CONTACT: "saveContact",
  SERVICE_UPDATE: "serviceUpdate",
};

export { APIURL };
